import { Link, redirect } from "react-router-dom"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import WithSidebar from "../../layouts/WithSidebar"
import List from "../List"
import ListHeader from "../List-header"
import './member.css'


const MemberList = () => {

    const [inputFields, handleChange, setInputFields] = useForm({
        search: {
            value: '',
            name: 'search',
            type: 'text',
            placeholder: 'Search...'
        }
    })

    const columns = [
        {name: 'Fullname'},
        {name: 'Role'},
        {name: 'Email Address'},
        {name: 'Phone number'},
        {name: 'Action'}
    ]

    const rows = [
        {name: 'Mehrab Lari', role: 'Admin', email: 'mehrablarii@gmail.com', mobile: '0935 110 3910'}
    ]

    return(
        <>
        <div className="member-list-filter">
            <Link className="add-member" to={"/agent/users/single"}> Add Member</Link>
            <div className="member-searchbar">
                <Input inputField={inputFields.search} onChange={handleChange}/>
            </div>
        </div>
        <List columns={columns} rows={rows} type={"members"}/>
        </>
    )
}
export default MemberList